import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PageNotFound from 'src/shared/components/page-not-found/PageNotFound';
import StacCatalogueList from './StacCatalogueList';
import StacCatalogueDetail from './StacCatalogueDetail';
import StacCollectionCreate from './StacCollectionCreate';
import StacCollectionEdit from './StacCollectionEdit';
import StacItemCreate from './StacItemCreate';
import StacItemEdit from './StacItemEdit';

/**
 * The catalogue's own routes. Datasets nest their versions, so this area owns a
 * subtree rather than a single page.
 */
const StacCatalogue = () => (
    <Routes>
        <Route index element={<StacCatalogueList />} />
        <Route path='new' element={<StacCollectionCreate />} />
        <Route path=':collectionId' element={<StacCatalogueDetail />} />
        <Route path=':collectionId/edit' element={<StacCollectionEdit />} />
        <Route path=':collectionId/versions/new' element={<StacItemCreate />} />
        <Route path=':collectionId/versions/:itemId/edit' element={<StacItemEdit />} />
        <Route path='*' element={<PageNotFound />} />
    </Routes>
);

export default StacCatalogue;
